import React, { useState, useEffect } from "react";
import { RotateCcw, X } from "lucide-react";

const ChatBotHeader = ({ imageurl,title, showExtraContent,setfloat_Visible ,float_visible,onRefresh}) => {


  const handleClose = () => {
  setfloat_Visible(false);
  // Also send close message to parent
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({
      type: 'CLOSE_CHAT'
    }, '*');
  }
};


  return (
 <header className="krunk-flex krunk-justify-between krunk-items-center krunk-gap-0 krunk-rounded-t-xl krunk-bg-headercolor krunk-text-headertextcolor krunk-px-4 krunk-py-3">
  <div className="krunk-flex krunk-items-center krunk-gap-2 krunk-w-full">
    <img
      src={imageurl}
      alt=""
      style={{ width: "40px", height: "40px" }}
    />
    <div className="krunk-w-full">
      <div className="krunk-flex krunk-items-center krunk-gap-3 krunk-justify-between">
        <h1 className="krunk-text-lg krunk-font-semibold krunk-leading-7">
          {title}
        </h1>
        <div className="krunk-flex krunk-items-center krunk-gap-2">
        <button
                onClick={onRefresh}
                className="krunk-text-headertextcolor hover:krunk-text-blue-400 krunk-transition-colors krunk-duration-200"
                title="Refresh Chat"
              >
                <RotateCcw className="krunk-w-5 krunk-h-5" />
              </button>
        {/* Cross Button */}
        <button
          onClick={handleClose}
          // onClick={onClose} // pass your close handler here
          className="krunk-text-headertextcolor hover:krunk-text-red-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="krunk-w-5 krunk-h-5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        </div>
      </div>
      <div className="krunk-flex krunk-items-center krunk-justify-between krunk-w-full">
        <div className="krunk-flex krunk-items-center krunk-gap-1"></div>
      </div>
    </div>
  </div>
</header>

  
  );
};

export default ChatBotHeader;
